var render = function () {
  var this$1 = this
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "drop-down",
    {
      attrs: {
        "should-close": _vm.shouldCloseDropdown,
        reduce: function (inv) {
          return inv.teamMemberInvoiceId
        },
      },
      on: {
        closeDropdown: function (val) {
          return (this$1.shouldCloseDropdown = val)
        },
        closeOtherDropDown: _vm.closeOtherDropDown,
      },
    },
    [
      _vm.isBulk
        ? _c(
            "span",
            {
              staticClass: "status bulk-status",
              attrs: { slot: "title", "data-toggle": "dropdown" },
              slot: "title",
            },
            [_vm._v("\n        CHANGE PAYMENT STATUS\n    ")]
          )
        : _c(
            "span",
            {
              staticClass: "status",
              class: [
                "payment-status-" +
                  _vm.invoiceDetails.status.toLowerCase().replace(/\s+/g, ""),
                { "dropdown-menu-disabled": _vm.disabled },
                _vm.shouldShowMobileStyle ? "mobile-status" : "",
              ],
              attrs: { slot: "title", "data-toggle": "dropdown" },
              slot: "title",
            },
            [
              !_vm.shouldShowMobileStyle
                ? _c("span", [
                    _vm._v(
                      _vm._s(
                        _vm.$t(
                          "inputs.paymentStatuses." + _vm.invoiceDetails.status
                        )
                      )
                    ),
                  ])
                : _c("span", [
                    _vm._v(_vm._s(_vm.invoiceDetails.status.charAt(0))),
                  ]),
            ]
          ),
      !_vm.disabled && !_vm.isTeamMember
        ? _c(
            "ul",
            {
              class: _vm.disabled ? "dropdown-menu-disabled" : "dropdown-menu",
            },
            _vm._l(_vm.statuses, function (status, index) {
              return _c("li", { key: index }, [
                _c(
                  "a",
                  {
                    on: {
                      click: function ($event) {
                        $event.stopPropagation()
                        return _vm.handleChangePaymentStatus(status.statusId)
                      },
                    },
                  },
                  [
                    _vm._v(
                      "\n                " +
                        _vm._s(status.statusValue) +
                        "\n            "
                    ),
                  ]
                ),
              ])
            }),
            0
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }